export const createStyles = (theme?: any) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    minWidth: 0,
    width: '100%',
  },
  accordion: {
    bgcolor: 'transparent',
    borderBottom: '1px solid',
    borderColor: 'divider',
    boxShadow: 'none',
    width: '100%',
    '&:before': { display: 'none' },
    '& .MuiAccordionSummary-root': {
      columnGap: '10px',
      minHeight: 0,
      px: 0,
      py: '20px',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': { minHeight: 0 },
    '& .MuiAccordionSummary-content': { my: 0 },
    '& .MuiAccordionSummary-content.Mui-expanded': { my: 0 },
    '& .MuiAccordionSummary-content .MuiTypography-root': {
      color: 'text.primary',
      fontSize: '1rem',
      fontWeight: 500,
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      color: 'text.primary',
      mr: 0,
    },
    '& .MuiAccordionDetails-root': { p: 0 },
    '& .MuiAccordionDetails-root > .MuiBox-root': {
      maxHeight: 'none',
      p: '12px 0 16px',
    },
  },
  table: {
    bgcolor: 'background.paper',
    borderColor: 'divider',
    borderRadius: 2,
    overflow: 'hidden',
    width: '100%',
    '& table': { tableLayout: 'fixed' },
    '& tbody .MuiTableRow-root:hover': { bgcolor: 'background.paper' },
    '& button[aria-label="row actions"]': {
      height: '24px',
      width: '24px',
      p: 0,
      '& .MuiSvgIcon-root': { fontSize: '24px' },
    },
  },
  tableHeader: {
    bgcolor: 'background.paper',
    borderBottom: 'none',
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: 500,
    py: '12px',
    textAlign: 'left',
  },
  tableCell: {
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: theme?.typography?.fontWeightRegular ?? 400,
    letterSpacing: '0.17px',
    lineHeight: '150%',
  },
  studentIdentity: {
    alignItems: 'center',
    display: 'flex',
    gap: '12px',
    width: '100%',
  },
  avatar: { flexShrink: 0, height: '40px', width: '40px' },
  name: {
    color: 'text.primary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: theme?.typography?.fontWeightRegular ?? 400,
    letterSpacing: '0.17px',
    lineHeight: '150%',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  rowValue: {
    color: 'text.primary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: theme?.typography?.fontWeightRegular ?? 400,
    letterSpacing: '0.17px',
    lineHeight: '150%',
  },
  cards: { display: 'flex', flexDirection: 'column', gap: '12px' },
  card: {
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    px: '16px',
    py: '12px',
    width: '100%',
  },
  clickableCard: {
    cursor: 'pointer',
    '&:focus-visible': {
      outline: '2px solid',
      outlineColor: 'primary.main',
      outlineOffset: '2px',
    },
  },
  cardHeader: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
    minHeight: '24px',
  },
  cardName: {
    color: 'text.primary',
    fontSize: '0.875rem',
    fontWeight: 500,
    overflowWrap: 'anywhere',
  },
  detail: {
    color: 'text.secondary',
    fontSize: '14px',
    lineHeight: 1.45,
  },
  detailLabel: { color: 'text.primary', fontWeight: 500 },
  empty: { color: 'text.secondary', p: '16px 0' },
  nestedGroups: { display: 'flex', flexDirection: 'column', gap: '8px' },
  nestedAccordion: {
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '8px !important',
    boxShadow: 'none',
    '&:before': { display: 'none' },
    '& .MuiAccordionSummary-content .MuiTypography-root': {
      color: 'text.primary',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    '& .MuiAccordionDetails-root': { p: 0 },
    '& .MuiAccordionDetails-root > .MuiBox-root': {
      maxHeight: 'none',
      p: '0 8px 8px',
    },
  },
});
